<template>
    <div class="confing-container">
        <el-form :model="formData" label-suffix=":" v-if="formItems.length">
            <template v-for="(item, index) in formItems" :key="index">
                <div class="group-container">
                    <p>{{ item.name }}</p>
                    <el-row>
                        <template v-if="item.is_threshold && item?.threshold_setting?.limit_setting">
                            <template v-for="limit in item?.threshold_setting.limit_setting" :key="limit.id">
                                <el-col :span="9">
                                    <el-form-item :label="limit.title" label-width="120px">
                                        <el-select
                                            v-if="limit.options"
                                            @change="onChangeLimit(item)"
                                            v-model="limit.value"
                                            style="width: 300px"
                                        >
                                            <el-option
                                                v-for="v in toArray(item?.threshold_setting.options)"
                                                :key="v.value"
                                                :label="v.label"
                                                :value="v.value"
                                            />
                                        </el-select>

                                        <template v-else>
                                            <template v-if="item?.threshold_setting?.input_type == 'number'">
                                                <el-input-number
                                                    @change="onChangeLimit(item)"
                                                    v-model="limit.value"
                                                ></el-input-number>
                                                <span v-if="item.threshold_setting.unit" style="margin-left: 10px">
                                                    ({{ item.threshold_setting.unit }})
                                                </span>
                                            </template>
                                            <el-input
                                                v-if="item?.threshold_setting?.input_type === 'string'"
                                                v-model="limit.value"
                                                @change="onChangeLimit(item)"
                                                :placeholder="limit?.placeholder ? limit.placeholder : '请输入'"
                                                style="width: 300px"
                                            >
                                                <template #append v-if="item.threshold_setting.unit">
                                                    {{ item.threshold_setting.unit }}
                                                </template>
                                            </el-input>
                                            <el-input
                                                v-if="item?.threshold_setting?.input_type === 'textarea'"
                                                type="textarea"
                                                @change="onChangeLimit(item)"
                                                v-model="limit.value"
                                                :placeholder="limit?.placeholder ? limit.placeholder : '请输入'"
                                                style="width: 800px"
                                            >
                                                <template #append v-if="item.threshold_setting.unit">
                                                    {{ item.threshold_setting.unit }}
                                                </template>
                                            </el-input>
                                            <!-- 密码框 -->
                                            <el-input
                                                v-if="item?.threshold_setting?.input_type === 'password'"
                                                type="password"
                                                @change="onChangeLimit(item)"
                                                v-model="limit.value"
                                                :placeholder="limit?.placeholder ? limit.placeholder : '请输入'"
                                                style="width: 300px"
                                            >
                                                <template #append v-if="item.threshold_setting.unit">
                                                    {{ item.threshold_setting.unit }}
                                                </template>
                                            </el-input>
                                            <!-- 下拉选 单选/多选 -->
                                            <el-select
                                                v-if="
                                                    item?.threshold_setting?.input_type === 'select' ||
                                                    item?.threshold_setting?.input_type === 'selects'
                                                "
                                                v-model="limit.value"
                                                style="width: 300px"
                                                @change="onChangeLimit(item)"
                                                :multiple="item?.threshold_setting?.input_type === 'selects'"
                                                :collapse-tags="item?.threshold_setting?.input_type === 'selects'"
                                                :collapse-tags-tooltip="item?.threshold_setting?.input_type === 'selects'"
                                                :placeholder="limit?.placeholder ? limit.placeholder : '请选择'"
                                            >
                                                <el-option
                                                    v-for="v in toArray(item?.threshold_setting.options)"
                                                    :key="v.value"
                                                    :label="v.label"
                                                    :value="v.value"
                                                />
                                            </el-select>
                                            <!-- 单选框 -->
                                            <el-radio-group
                                                @change="onChangeLimit(item)"
                                                v-if="item?.threshold_setting?.input_type === 'radio'"
                                                v-model="limit.value"
                                            >
                                                <el-radio
                                                    v-for="v in toArray(limit.options)"
                                                    :disabled="
                                                        limit.pid === 'pdu_outlet_turn_operation'
                                                            ? associatedChannel(limit)
                                                            : false
                                                    "
                                                    :key="v.value"
                                                    :label="v.value"
                                                >
                                                    {{ v.label }}
                                                </el-radio>
                                            </el-radio-group>
                                            <!-- 复选选框 -->
                                            <el-checkbox-group
                                                @change="onChangeLimit(item)"
                                                v-if="item?.threshold_setting?.input_type === 'checkbox'"
                                                v-model="limit.value"
                                            >
                                                <el-checkbox v-for="v in toArray(limit.options)" :key="v.value" :label="v.value">
                                                    {{ v.label }}
                                                </el-checkbox>
                                            </el-checkbox-group>
                                            <!-- 开关 -->
                                            <el-switch
                                                v-if="item?.threshold_setting?.input_type === 'switch'"
                                                v-model="limit.value"
                                                @change="onChangeLimit(item)"
                                                :active-value="1"
                                                :inactive-value="0"
                                            />
                                            <!-- 日期 -->
                                            <el-date-picker
                                                v-if="
                                                    item?.threshold_setting?.input_type == 'datetime' ||
                                                    item?.threshold_setting?.input_type == 'year' ||
                                                    item?.threshold_setting?.input_type == 'date'
                                                "
                                                v-model="limit.value"
                                                :type="item?.threshold_setting?.input_type"
                                                :placeholder="limit?.placeholder ? limit.placeholder : '请选择日期'"
                                                style="width: 300px"
                                                @change="onChangeLimit(item)"
                                                :value-format="
                                                    item?.threshold_setting?.input_type == 'datetime'
                                                        ? 'YYYY-MM-DD HH:mm:ss'
                                                        : item?.threshold_setting?.input_type == 'year'
                                                        ? 'YYYY'
                                                        : 'YYYY-MM-DD'
                                                "
                                            />
                                            <!-- 时间 -->
                                            <el-time-picker
                                                v-if="item?.threshold_setting?.input_type == 'time'"
                                                v-model="limit.value"
                                                :placeholder="limit?.placeholder ? limit.placeholder : '请选择时间'"
                                                style="width: 300px"
                                                @change="onChangeLimit(item)"
                                                value-format="HH:mm:ss"
                                            />
                                            <!-- 告警信息 -->
                                        </template>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="告警信息" label-width="80px">
                                        <el-input
                                            v-model="limit.alarm_msg"
                                            @change="onChangeLimit(item)"
                                            placeholder="请输入告警信息"
                                            style="width: 300px"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </template>
                        </template>

                        <el-col :span="4">
                            <el-form-item label="告警等级" label-width="80px">
                                <el-select
                                    v-model="item.level"
                                    @change="onChangeLimit(item)"
                                    placeholder="请选择告警级别"
                                    style="width: 300px"
                                >
                                    <el-option v-for="v in alarmLevelOptionData" :key="v.id" :label="v.label" :value="v.level">
                                        {{ v.label }}-{{
                                            `声光报警：${v.sound_light ? '是' : '否'}，是否短信：${
                                                v.is_message ? '是' : '否'
                                            }，是否录制：${v.is_record ? '是' : '否'}`
                                        }}
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item label="是否启用" label-width="100px">
                                <el-switch
                                    v-model="item.status"
                                    :active-value="1"
                                    :inactive-value="0"
                                    @change="(val) => handleStatus(val, item)"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </template>
        </el-form>
        <el-empty v-else image="@assets/images/noData.png" :image-size="400"></el-empty>
    </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { getAlarmLevelLists } from '@/api/eventConfig/alarmLevel/alarmLevel.js'
import { addEventSourceSetting, getEventSourceSettingOptionLists } from '@/api/eventConfig/eventManger/eventSourceSetting'
import { ElMessage, ElMessageBox } from 'element-plus'

const route = useRoute()
const formData = ref({})
const formItems = ref([])

// 告警级别选项
const alarmLevelOptionData = ref([])
//
const getOptionData = async () => {
    alarmLevelOptionData.value = await getAlarmLevelLists()
}

// 配置项
const getConfigItemOptionListFn = async () => {
    const module = route.query.module || ''
    const data = await getEventSourceSettingOptionLists({
        module: module,
        is_set: 1
    })
    if (data.length) {
        // console.log(data)
        data.forEach((limit) => {
            if (limit.is_threshold && limit.threshold_setting) {
                if (limit.threshold_setting.data_type === 'int' || limit.data_type === 'float') {
                    if (data.threshold_setting?.limit_setting && data.threshold_setting?.limit_setting?.length) {
                        data.threshold_setting.limit_setting.forEach((item) => {
                            item.value = limit.value ? Number(limit.value) : 0
                        })
                    }
                }
                if (limit.threshold_setting?.limit_setting?.length) {
                    limit.threshold_setting.limit_setting.forEach((item) => {
                        item.initValue = item.value
                    })
                }
            }
        })
        formItems.value = data
    } else {
        formData.value = {}
        formItems.value = []
    }
}
// options转数组
const toArray = (data) => {
    const list = []
    for (const key in data) {
        list.push({
            value: key,
            label: data[key]
        })
    }
    console.log(list)
    return list
}

// 失去焦点提交
const onChangeLimit = async (limit) => {
    const postData = {}
    // 是否为阈值设置
    if (limit.is_threshold && limit.threshold_setting && limit.threshold_setting?.limit_setting?.length) {
        postData.code = limit.code
        postData.level = limit.level
        postData.limit_setting = limit.threshold_setting.limit_setting
    } else {
        postData.code = limit.code
        postData.level = limit.level
    }
    try {
        await addEventSourceSetting(postData)
        ElMessage.success('保存成功')
        getConfigItemOptionListFn()
    } catch (error) {}
}

// 修改状态
const handleStatus = (val, row) => {
    if (!row.code) return
    const msg = val ? '启用' : '停用'
    ElMessageBox.confirm(`是否确认要 ${msg} ${row.name} 吗？`, '系统提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            try {
                await addEventSourceSetting({ code: row.code, status: val })
                getConfigItemOptionListFn()
                ElMessage.success(msg + '成功')
            } catch (error) {}
        })
        .catch(() => {
            row.status = val ? 0 : 1
        })
}

onMounted(async () => {
    await getOptionData()
    await getConfigItemOptionListFn()
})
</script>
<style scoped lang="scss">
.el-empty {
    margin: 0 auto;
}

:deep(.el-form-item) {
    margin-bottom: 0;
    padding: 15px 0px;
}

:deep(.el-row) {
    border-bottom: 1px solid #ebf0fc;
}
.module-box {
    width: 150px;
    background-color: #fafcfe;
    box-sizing: border-box;
    font-size: 14px;
    border-right: 1px solid #d9d9e1;
    height: calc(100vh - 125px);
    border-bottom-left-radius: 15px;

    h4 {
        padding: 10px 20px;
        line-height: 28px;
        font-weight: normal;
        color: #7c7e82;
        // border-bottom: 1px solid #ddd;
        font-size: 14px;
        display: flex;
        align-items: center;
    }

    li {
        padding: 12px 20px;
        cursor: pointer;
        position: relative;
        color: #232323;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &:hover {
            background-color: var(--el-color-primary-light-9);
        }
    }

    .active {
        background-color: var(--el-color-primary-light-9);

        // border-right: 2px solid #4291F7;
        &::after {
            position: absolute;
            right: -1px;
            top: 0;
            content: '';
            width: 2px;
            height: 100%;
            background-color: #4291f7;
        }
    }
}

.confing-container {
    width: 100%;
    overflow-y: auto;
    display: flex;
    margin-top: -10px;
}

.el-form {
    box-sizing: border-box;
    margin-bottom: 10px;
    height: calc(100vh - 113px);
    overflow-y: auto;
    flex: 1;
    padding: 20px 0 20px 20px;
    // width: 50%;
    // margin: 0 auto;
}

.group-container {
    // border: 1px solid #cbc9c9;
    border-radius: 20px;
    // padding: 20px;
    box-sizing: border-box;
    position: relative;

    p {
        font-weight: 700;
        background-color: #f1f5fd;
        padding: 10px 20px;
        border-left: 2px solid #63a4f7;
    }
}
</style>
